import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { IconButton } from '@totalsoft/rocket-ui';
import { ThinCheckbox } from 'components/common/Styles';
import TextTableCell from 'components/common/table/TextTableCell';

const GenericFilterTemplateItemComponent = ({ data }) => {
  const [t] = useTranslation();

  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/genericFilterTemplates/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.name}</TableCell>
      <TextTableCell content={data.filterCondition} />
      <TableCell align='center'>
        <ThinCheckbox checked={data.isTemplate} disabled />
      </TableCell>
      <TableCell align='right'>
        <IconButton color='primary' variant='text' size='small' type='edit' tooltip={t('InsuranceConventions.Edit')} onClick={handleEdit} />
      </TableCell>
    </TableRow>
  );
};

GenericFilterTemplateItemComponent.propTypes = {
  data: PropTypes.object
};

export default GenericFilterTemplateItemComponent;
